<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增产品"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
      scrollable
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="name" label="名称">
          <!-- <mu-text-field v-model="form.name"></mu-text-field> -->
          <mu-auto-complete
            :data="nameList"
            :max-search-results="8"
            v-model="form.name"
            open-on-focus
          ></mu-auto-complete>
        </mu-form-item>

        <mu-form-item prop="specification" label="规格">
          <mu-text-field
            v-model="form.specification"
            help-text="长*宽,单位mm"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="thickness" label="厚度">
          <mu-text-field
            v-model="form.thickness"
            help-text="mm"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="weight" label="重量" v-if="!isSimple">
          <mu-text-field v-model="form.weight" help-text="kg"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="materialPrice" label="材料单价">
          <mu-text-field
            v-model="form.materialPrice"
            help-text="元/kg"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="materialSum" label="材料总价" error-text="元">
          <mu-text-field v-model="form.materialSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="laserLength" label="切割长度" v-if="!isSimple">
          <mu-text-field
            v-model="form.laserLength"
            help-text="米"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="laserPrice" label="切割单价" v-if="!isSimple">
          <mu-text-field
            v-model="form.laserPrice"
            help-text="元/米"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item
          prop="laserSum"
          label="切割总价"
          :error-text="`元,${isSimple ? '切割+穿孔' : '不含穿孔'}`"
        >
          <mu-text-field v-model="form.laserSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="kongCount" label="穿孔数量" v-if="!isSimple">
          <mu-text-field
            v-model="form.kongCount"
            help-text="个"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="kongPrice" label="穿孔单价" v-if="!isSimple">
          <mu-text-field
            v-model="form.kongPrice"
            help-text="元/个"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item
          prop="kongSum"
          label="穿孔总价"
          v-if="!isSimple"
          error-text="元"
        >
          <mu-text-field v-model="form.kongSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="bendSum" label="折弯总价" error-text="元">
          <mu-text-field v-model="form.bendSum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="unit" label="单位">
          <mu-select v-model="form.unit">
            <mu-option
              v-for="(item, index) in unitList"
              :key="index"
              :value="item"
              :label="item"
            ></mu-option>
          </mu-select>
        </mu-form-item>

        <mu-form-item prop="isBYO" label="是否自带料">
          <mu-switch
            v-model="form.isBYO"
            :label="form.isBYO ? '是' : '否'"
          ></mu-switch>
        </mu-form-item>

        <mu-form-item prop="price" label="单价" error-text="元">
          <mu-text-field v-model="form.price"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="count" label="数量">
          <mu-text-field v-model="form.count"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="总价" error-text="元">
          <mu-text-field v-model="form.sum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="pic" label="图片">
          <div
            class="pic-upload"
            :contenteditable="form.pic === ''"
            @paste="paste"
            v-loading="imgLoading"
          >
            <img :src="form.pic" v-if="form.pic" />
            <mu-button
              fab
              color="red"
              class="delete-button"
              small
              @click="form.pic = ''"
              v-if="form.pic"
            >
              <mu-icon value="clear"></mu-icon>
            </mu-button>
            <div class="placeholder" v-else>将图片复制至此处</div>
          </div>
        </mu-form-item>
      </mu-form>
      <mu-switch slot="actions" v-model="isSimple" label="简易模式"></mu-switch>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button
        slot="actions"
        color="primary"
        @click="submit"
        v-loading="loading"
        >提交</mu-button
      >
    </mu-dialog>
  </div>
</template>

<script>
import numeral from 'numeral'
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSimple: true,
      form: {
        name: '',
        specification: '',
        price: 1,
        count: 1,
        sum: 1,
        pic: '',
        isBYO: false,
        unit: '件',
        thickness: 0,
        laserLength: 0,
        kongCount: 0,
        kongPrice: 0,
        weight: 0,
        laserPrice: 0,
        materialPrice: 4.7,
        materialSum: 0,
        laserSum: 0,
        kongSum: 0,
        bendSum: 0
      },
      imgLoading: false,
      loading: false,
      unitList: ['件', '套', '米', '平米', '公斤'],
      thicknessList: [
        1, 1.2, 1.5, 2, 3, 4, 5, 6, 8, 10, 12, 14, 16, 18, 20, 25, 30
      ],
      nameList: []
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          this.loading = true
          backend(api.product.create, this.form).then((result) => {
            this.loading = false
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish', result.data)
              this.form = {
                name: '',
                specification: '',
                price: 1,
                count: 1,
                sum: 1,
                pic: '',
                isBYO: false,
                unit: '件',
                thickness: 0,
                laserLength: 0,
                kongCount: 0,
                kongPrice: 0,
                weight: 0,
                laserPrice: 0,
                materialPrice: 4.7,
                materialSum: 0,
                laserSum: 0,
                kongSum: 0,
                bendSum: 0
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    },
    paste(e) {
      e.preventDefault()
      if (e.clipboardData.types[0] === 'Files') {
        const file = e.clipboardData.items[0].getAsFile()
        this.picUpload(file)
      }
    },
    picUpload(file) {
      this.imgLoading = true
      const formData = new FormData()
      formData.append('file', file)
      backend(api.product.picUpload, formData).then((result) => {
        this.imgLoading = false
        if (result.statusCode === 200) {
          this.form.pic = result.data.url
        }
      })
    },
    nameListInit() {
      const list = []
      this.thicknessList.forEach((item) => {
        list.push(item + 'mm碳钢')
        list.push(item + 'mm不锈钢')
        list.push(item + 'mm铝板')
      })
      this.nameList = list
    },
    getMaterialSum() {
      const arr = this.form.specification.split('*')
      if (arr.length === 2) {
        this.form.weight = this.ceil(
          numeral(arr[0])
            .multiply(arr[1])
            .divide(1000)
            .divide(1000)
            .multiply(this.form.thickness)
            .multiply(7.9)
            .value(),
          2
        )
        this.form.materialSum = this.ceil(
          numeral(this.form.weight).multiply(this.form.materialPrice).value(),
          2
        )
      }
    },
    getLaserSum() {
      this.form.laserSum = this.ceil(
        numeral(this.form.laserLength).multiply(this.form.laserPrice).value(),
        2
      )
    },
    getKongSum() {
      this.form.kongSum = this.ceil(
        numeral(this.form.kongCount).multiply(this.form.kongPrice).value(),
        2
      )
    },
    getPrice() {
      this.form.price = this.ceil(
        numeral(this.form.materialSum)
          .add(this.form.laserSum)
          .add(this.form.kongSum)
          .add(this.form.bendSum)
          .value(),
        1
      )
    },
    getSum() {
      this.form.sum = this.ceil(
        numeral(this.form.count).multiply(this.form.price).value(),
        1
      )
    },
    // 进一法保留小数
    ceil(number, length) {
      return Math.ceil(number * Math.pow(10, length)) / Math.pow(10, length)
    }
  },
  watch: {
    'form.specification': {
      handler(val) {
        if (val) {
          this.getMaterialSum()
        }
      },
      deep: true
    },
    'form.thickness': {
      handler(val) {
        if (val) {
          this.getMaterialSum()
        }
      },
      deep: true
    },
    'form.materialPrice': {
      handler(val) {
        if (val) {
          this.getMaterialSum()
        }
      },
      deep: true
    },
    'form.laserLength': {
      handler(val) {
        if (val) {
          this.getLaserSum()
        }
      },
      deep: true
    },
    'form.laserPrice': {
      handler(val) {
        if (val) {
          this.getLaserSum()
        }
      },
      deep: true
    },
    'form.kongCount': {
      handler(val) {
        if (val) {
          this.getKongSum()
        }
      },
      deep: true
    },
    'form.kongPrice': {
      handler(val) {
        if (val) {
          this.getKongSum()
        }
      },
      deep: true
    },
    'form.materialSum': {
      handler(val) {
        if (val) {
          this.getPrice()
        }
      },
      deep: true
    },
    'form.laserSum': {
      handler(val) {
        if (val) {
          this.getPrice()
        }
      },
      deep: true
    },
    'form.kongSum': {
      handler(val) {
        if (val) {
          this.getPrice()
        }
      },
      deep: true
    },
    'form.bendSum': {
      handler(val) {
        if (val) {
          this.getPrice()
        }
      },
      deep: true
    },
    'form.price': {
      handler(val) {
        if (val) {
          this.getSum()
        }
      },
      deep: true
    },
    'form.count': {
      handler(val) {
        if (val) {
          this.getSum()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.nameListInit()
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
  .pic-upload {
    width: 100%;
    height: 300px;
    border: 2px dashed #ddd;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .delete-button {
      position: absolute;
      top: 0px;
      right: 0px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/create.vue